import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="link-overlay"
export default class extends Controller {
  static targets = ["mainLink"];
  
  clickableTagTypes = ["a", "button", "input"];

  handleClick(e){
    if (
      this.hasMainLinkTarget
      && this.mainLinkTarget !== e.target
      && !this.clickableTagTypes.includes(e.target.tagName.toLowerCase())
    ) {
      this.mainLinkTarget.click();
    }
  }
}
